import { gql } from '@apollo/client';

export const CREATE_SCHOOL_ATTENDANCE_DATAS = gql`
  mutation createSchoolAttendanceDatas($inputs: [CreateSchoolAttendanceDataInput!]!) {
    attendances: createSchoolAttendanceDatas(inputs: $inputs) {
      id
    }
  }
`;
